import { render, staticRenderFns } from "./dre-lista.vue?vue&type=template&id=29d79e1f&"
import script from "./dre-lista.vue?vue&type=script&lang=js&"
export * from "./dre-lista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports